import { createSoAtlantaClient, readJsonScript } from '@theme/so-atlanta-api';

class SoAtlantaHomepageAd extends HTMLElement {
  #client = null;
  #settings = {};
  #connected = false;

  connectedCallback() {
    this.#connected = true;
    this.#settings = readJsonScript(this, '[data-homepage-ad-settings]');
    this.#client = createSoAtlantaClient(this.#settings);
    void this.#hydrate();
  }

  disconnectedCallback() {
    this.#connected = false;
  }

  async #hydrate() {
    if (!this.#settings.enabled || !this.#client) return;
    try {
      const ad = await this.#client.adSlot({ placement: 'homepage_midpage' });
      if (this.#connected) this.#render(ad);
    } catch (error) {
      console.warn('So Atlanta homepage ad unavailable', error);
    }
  }

  /** @param {any} ad */
  #render(ad) {
    const slot = this.querySelector('[data-homepage-ad-slot]');
    if (!(slot instanceof HTMLElement) || !ad || typeof ad !== 'object') return;

    const link = document.createElement('a');
    link.className = 'sa-home-ad__link';
    link.href = String(ad.landingPageUrl || this.#settings.fallbackUrl || 'https://partners.soatlantastore.com/campaigns');
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    const assetUrl = String(ad.assetUrl || '').trim();
    if (assetUrl) {
      const media = document.createElement('span');
      media.className = 'sa-home-ad__media';
      const image = document.createElement('img');
      image.src = assetUrl;
      image.alt = '';
      image.loading = 'lazy';
      media.append(image);
      link.append(media);
    } else {
      link.classList.add('sa-home-ad__link--no-media');
    }

    const copy = document.createElement('span');
    copy.className = 'sa-home-ad__copy';

    const eyebrow = document.createElement('span');
    eyebrow.className = 'sa-home-ad__eyebrow';
    eyebrow.textContent = String(ad.label || 'Sponsored');

    const title = document.createElement('strong');
    title.textContent = String(ad.title || 'Your ad here');

    const detail = document.createElement('span');
    detail.textContent = String(ad.advertiserBusiness?.name || ad.copy || 'Homepage mid-page placement');

    copy.append(eyebrow, title, detail);
    link.append(copy);
    slot.replaceChildren(link);
  }
}

if (!customElements.get('so-atlanta-homepage-ad')) {
  customElements.define('so-atlanta-homepage-ad', SoAtlantaHomepageAd);
}
